import { z } from 'zod';
// SMTP konfigurasyonu (Ayar.deger icinde JSON-string olarak tutulur)
export const smtpAyar = z.object({
    host: z.string().min(1),
    port: z.number().int().min(1).max(65535),
    secure: z.boolean(), // true=465 (TLS), false=587 (STARTTLS)
    user: z.string().min(1),
    sifre: z.string().min(1), // saklanir ama yanitlarda gosterilmez
    fromEmail: z.string().email(),
    fromName: z.string().min(1),
});
// SMTP test isteği — admin sayfasinda "Test gonder" butonu
export const smtpTestIstegi = z.object({
    alici: z.string().email(),
});
// NetGSM konfigurasyonu
export const netgsmAyar = z.object({
    apiUrl: z.string().url().default('https://api.netgsm.com.tr'),
    kullaniciAdi: z.string().min(1),
    sifre: z.string().min(1),
    baslik: z.string().min(1), // gonderici basligi (orn. EMANETX)
});
export const netgsmTestIstegi = z.object({
    telefon: z.string().regex(/^\+[1-9]\d{7,14}$/),
    mesaj: z.string().min(1).max(160),
});
// Akbank Sanal POS konfigurasyonu (Faz C'de kullanilir)
export const akbankAyar = z.object({
    merchantSafeId: z.string().length(32),
    terminalSafeId: z.string().length(32),
    secretKey: z.string().min(32),
    prod: z.boolean().default(false),
});
//# sourceMappingURL=platform-ayar.js.map